import NewSegments from "./NewSegments";
import Loader from "../../../components/loader/Loader";
import {WarningIcon} from "../../../assets/icons/WarningIcon";
import CountUp from "react-countup";
import {Button, Tooltip} from "antd";
import {useEffect, useRef, useState} from "react";
import {useSteps} from "../../../hooks/useSteps";
import LongArrowLeft from "../../../assets/icons/LongArrowLeft";
import {ConditionsProps, defaultConditions} from "../../../utils/segmentBuilder";
import useToast from "../../../hooks/useToast";
import {ToastSkin} from "../../../context/ToastContext";
import {TrashIcon} from "../../../assets/icons/TrashIcon";

interface SegmentConditionBuilderProps {
    isOpen: boolean;
    onSubmit: (segmentState: ConditionsProps[]) => Promise<boolean>;
    initialSegmentState?: ConditionsProps[];
    isSubmitting: boolean;
    isNew: boolean;
    deleteSegment?: () => void;
}

const SegmentConditionBuilder = ({ isOpen, onSubmit, initialSegmentState = [defaultConditions], isSubmitting, isNew, deleteSegment }: SegmentConditionBuilderProps) => {
    const [newSegmentSession, setNewSegmentSession] = useState(0);
    const [isValid, setIsValid] = useState(false);
    const previousCount = useRef(0);
    const [currentCount, setCurrentCount] = useState(0);
    const [isLoadingCount, setIsLoadingCount] = useState(false);
    const { goBack, goNext, goToStep } = useSteps();
    const [segmentState, setSegmentState] = useState<ConditionsProps[]>(initialSegmentState);
    const { showToast } = useToast();

    const onSubmitClick = async () => {
        const response = await onSubmit(segmentState);
        if(response) {
            goNext();
        } else {
            showToast({ skin: ToastSkin.error, text: 'Segment creation failed. Try again or contact support.'});
        }
    }

    useEffect(() => {
        if(!isOpen) {
            goToStep(1);
        }
    }, [isOpen]);

    useEffect(() => {
        previousCount.current = currentCount;
    }, [currentCount]);

    useEffect(() => {
        setSegmentState(initialSegmentState);
    }, [initialSegmentState]);

    return (
        <div>
            <div className="segment-conditions-list">
                {isNew ? null : <div className="condition-section-title">Segment Conditions</div>}
                <NewSegments newSegmentSession={newSegmentSession} setIsValid={setIsValid} updateCustomersCount={setCurrentCount}  setIsLoadingCount={setIsLoadingCount} segmentState={segmentState} setSegmentState={setSegmentState} />
            </div>
            <div className="modal-footer">
                <div className="flex segment-counter">
                    <div className={`flex estimation ${isValid ? '' : 'error'}`}>
                        {isLoadingCount ? <Loader size={24} isFullPage={false} /> : null}
                        <div>
                            Estimated{' '}
                            <span>
                                {isValid ? null : <WarningIcon width={24} color="#e5e5e5" /> }
                                <CountUp
                                    start={previousCount.current}
                                    end={currentCount}
                                    duration={0.6}
                                    separator=","
                                    preserveValue={true} // optional if you use key trick instead
                                />
                                    </span>
                            {' '}customers will be targeted.
                        </div>
                    </div>
                    <div className="description">* Final count may vary until the message is sent.</div>
                </div>
                <div className="flex actions">
                    {deleteSegment && !isNew ?
                        <Button size="large" type="default" onClick={deleteSegment} icon={<TrashIcon width={18} />} disabled={isSubmitting}>Delete</Button> :
                        <Button size="large" type="default" onClick={goBack} icon={<LongArrowLeft width={14} />} disabled={isSubmitting}>Back</Button>
                    }
                    <Tooltip title={isValid ? '' : 'Ensure all segment conditions are valid before creating the segment.'}>
                        <Button size="large" type="primary" disabled={!isValid || isSubmitting} onClick={onSubmitClick}>{isNew ? 'Create Segment' : 'Update Segment'}</Button>
                    </Tooltip>
                </div>
            </div>
        </div>
    );
}

export default SegmentConditionBuilder;